export const VIDEO_AD_CONTAINER_ID = 'videoAdContainer';
export const PREROLL_SLOT_NAME = 'preroll';
export const MIDROLL_SLOT_NAME = 'midroll';
